import { Navigate } from '@ngxs/router-plugin';

export function statusCodeErrorHandler(error, dispatch) {
  if (error.status === 403 || error.status === 409) {
    dispatch(new Navigate(['/']));
  } else {
    console.error('An error occurred:', error);
  }
}
